import { Link } from "react-router-dom";

const categoryLinks = [
  { to: "/category/电影", label: "电影" },
  { to: "/category/电视剧", label: "电视剧" },
  { to: "/category/综艺", label: "综艺" },
  { to: "/category/动漫", label: "动漫" },
];

const siteLinks = [
  { to: "/", label: "首页" },
  { to: "/special", label: "影视专题" },
  { to: "/search", label: "搜索影视" },
  { to: "/favorites", label: "我的收藏" },
  { to: "/about", label: "关于我们" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 pb-24 pt-12 md:px-6 lg:pb-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-movie-2-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-extrabold">91免费看片</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-background-100/70">
              高清影视在线观看平台，汇聚电影、电视剧、综艺、动漫等丰富资源，便捷查找，随心观看。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <span className="text-accent-400">#</span> 影视分类
            </h4>
            <ul className="mt-3 space-y-2 text-sm text-background-100/70">
              {categoryLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="transition-colors hover:text-accent-400">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <span className="text-accent-400">#</span> 站点导航
            </h4>
            <ul className="mt-3 space-y-2 text-sm text-background-100/70">
              {siteLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="transition-colors hover:text-accent-400">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <span className="text-accent-400">#</span> 联系我们
            </h4>
            <ul className="mt-3 space-y-2 text-sm text-background-100/70">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                <span>feedback@91kanpian.example</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" />
                <span>每日 00:00 - 24:00 持续更新</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-100/15 pt-6">
          <p className="text-xs leading-relaxed text-background-100/55">
            免责声明：本站为前端演示站点，所有影视名称、海报及资料均为虚构示例，仅用于界面展示与技术演示，不含任何真实影视资源与在线播放服务。如涉及版权问题请联系我们处理。
          </p>
          <div className="mt-4 flex flex-col gap-2 text-xs text-background-100/60 sm:flex-row sm:items-center sm:justify-between">
            <span>© 2026 91免费看片 · 高清影视在线观看平台</span>
            <span>本站内容仅供学习与演示使用</span>
          </div>
        </div>
      </div>
    </footer>
  );
}